import { render, staticRenderFns } from "./MarcaSelect.vue?vue&type=template&id=75e567f4&"
import script from "./MarcaSelect.vue?vue&type=script&lang=js&"
export * from "./MarcaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports